import { render, staticRenderFns } from "./zhibo.vue?vue&type=template&id=5a9a80b7&scoped=true&"
var script = {}
import style0 from "./zhibo.vue?vue&type=style&index=0&id=5a9a80b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9a80b7",
  null
  
)

export default component.exports